import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { convertServerResponsivePropertyToClientResponsiveProperty, getResponsiveStylingClassNames } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/responsiveValues";
import { getWidthConstraintCSS } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/widthConstraint";
import * as styles from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/BannerTextContent/styles/SDUIBannerTextContent.css";
import { SDUIBannerCTARenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/SDUIBannerCTARenderer";
import { SDUIButtonRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Button/SDUIButtonRenderer";
import { SDUITypographyRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
// eslint-disable-next-line no-restricted-imports
import { assignInlineVars } from "@vanilla-extract/dynamic";
import classNames from "classnames";
import React from "react";
export var SDUIBannerTextContent = function(param) {
    var dataTestId = param["data-test-id"], className = param.className, bannerComponent = param.bannerComponent, loggingData = param.loggingData;
    var tagline = bannerComponent.tagline, title = bannerComponent.title, sub_title = bannerComponent.sub_title, description = bannerComponent.description, button = bannerComponent.button, style = bannerComponent.style;
    var _ref = style !== null && style !== void 0 ? style : {}, description_width = _ref.description_width, responsive_description_width = _ref.responsive_description_width, header_width = _ref.header_width, responsive_header_width = _ref.responsive_header_width;
    var responsiveDescriptionWidth = convertServerResponsivePropertyToClientResponsiveProperty(description_width, getWidthConstraintCSS, responsive_description_width);
    var responsiveHeaderWidth = convertServerResponsivePropertyToClientResponsiveProperty(header_width, getWidthConstraintCSS, responsive_header_width);
    var _obj;
    return /*#__PURE__*/ _jsxs(Column, {
        className: className,
        "data-test-id": dataTestId,
        style: {
            position: "relative"
        },
        justify: "center",
        children: [
            tagline ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                        textElement: tagline,
                        loggingData: loggingData
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: {
                            mobileAndAbove: "1x",
                            tabletAndAbove: "2x"
                        }
                    })
                ]
            }) : null,
            title ? /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                className: classNames(getResponsiveStylingClassNames(responsiveHeaderWidth, {
                    mobileAndAbove: styles.mobileAndAboveTitleWidth,
                    tabletAndAbove: styles.tabletAndAboveTitleWidth,
                    desktopAndAbove: styles.desktopAndAboveTitleWidth
                })),
                componentStyle: assignInlineVars((_obj = {}, _define_property(_obj, styles.varMobileTitleWidth, responsiveHeaderWidth.mobileAndAbove), _define_property(_obj, styles.varTabletTitleWidth, responsiveHeaderWidth.tabletAndAbove), _define_property(_obj, styles.varDesktopTitleWidth, responsiveHeaderWidth.desktopAndAbove), _obj)),
                textElement: title,
                loggingData: loggingData
            }) : null,
            sub_title ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    }),
                    /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                        textElement: sub_title,
                        loggingData: loggingData
                    })
                ]
            }) : null,
            description.length > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: {
                            mobileAndAbove: "1x",
                            tabletAndAbove: "2x"
                        }
                    }),
                    description.map(function(descriptionElement, index) {
                        var _obj;
                        return /*#__PURE__*/ _jsxs(React.Fragment, {
                            children: [
                                index > 0 ? /*#__PURE__*/ _jsx(Spacer, {
                                    height: "1/2x"
                                }) : null,
                                /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                                    className: classNames(getResponsiveStylingClassNames(responsiveDescriptionWidth, {
                                        mobileAndAbove: styles.mobileAndAboveDescriptionWidth,
                                        tabletAndAbove: styles.tabletAndAboveDescriptionWidth,
                                        desktopAndAbove: styles.desktopAndAboveDescriptionWidth
                                    })),
                                    componentStyle: assignInlineVars((_obj = {}, _define_property(_obj, styles.varMobileDescriptionWidth, responsiveDescriptionWidth.mobileAndAbove), _define_property(_obj, styles.varTabletDescriptionWidth, responsiveDescriptionWidth.tabletAndAbove), _define_property(_obj, styles.varDesktopDescriptionWidth, responsiveDescriptionWidth.desktopAndAbove), _obj)),
                                    textElement: descriptionElement,
                                    loggingData: loggingData
                                })
                            ]
                        }, index);
                    })
                ]
            }) : null,
            button ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "2x"
                    }),
                    /*#__PURE__*/ _jsx(SDUIButtonRenderer, {
                        className: styles.bannerButton,
                        buttonElement: button,
                        loggingData: loggingData,
                        fireLegacyOnClickEvent: true
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(SDUIBannerCTARenderer, {
                bannerComponent: bannerComponent
            })
        ]
    });
};
